import { observables } from './observables.js';
import { header } from './header.js';
import { initializeDropdownMenu } from './mobile-menu.js';
import { searchMenuMobile } from './search-menu-mobile.js';
import { gallerySlider } from './gallery-slider.js';
import { initCTAList } from './cta-list.js';
import { initMediaScaleEffect } from './large-feature.js';
import { initQuote } from './quote.js';
import { initTextWithImage } from './text-with-image.js';
import { OySwipers } from './swipers.js';
import { initUpcomingEvents } from './upcoming-events.js';
import { initStaffAccordion } from './staff_accordion.js';
import { initAccordion } from './accordion.js';
import { initSystemMessages } from './system-messages.js';
import { curriculumNav } from './curriculum.js';
import { countDownClock } from './count-down-clock.js';
 
document.addEventListener( 'DOMContentLoaded', () => {
	observables();
	header();
	initializeDropdownMenu();
	searchMenuMobile();
	gallerySlider();
	initCTAList();
	initMediaScaleEffect();
	initQuote();
	initTextWithImage();
	new OySwipers();
	initUpcomingEvents();
	initStaffAccordion();
	initAccordion();
	initSystemMessages();
	countDownClock();
	curriculumNav();
	
});